export const LIST_NAME = 'APPS_BY_ACTIVITY_TAG'
export const STATUS_FIELD = 'status'
export const TAG_ID_FIELD = 'tag_id'
